import { render, staticRenderFns } from "./Duplicate.vue?vue&type=template&id=47209927"
import script from "./Duplicate.vue?vue&type=script&lang=js"
export * from "./Duplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports